import { Controller } from "@hotwired/stimulus"

const IFRAME_ALLOW = "camera *; microphone *; geolocation *; clipboard-read *; clipboard-write *; gyroscope *; accelerometer *; magnetometer *; ch-ua-platform-version *; ch-ua-model *; ch-ua-full-version *"

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  }

  connect() {
    this.initWidget()
  }

  disconnect() {
    this.iframeObserver?.disconnect()
  }

  initWidget() {
    this.observeIframeInsertion()
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        onMyAccount: () => this.redirectToNextStep(false),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    )
  }

  observeIframeInsertion() {
    const container = document.getElementById(this.widgetIdValue)
    if (!container) return

    this.iframeObserver = new MutationObserver(() => {
      const frame = container.querySelector("iframe")
      if (!frame) return

      this.iframeObserver.disconnect()
      frame.setAttribute("allow", IFRAME_ALLOW)
      frame.setAttribute("src", frame.getAttribute("src"))
    })
    this.iframeObserver.observe(container, { childList: true, subtree: true })
  }

  redirectToNextStep(success = false) {
    const url = new URL(this.redirectUrlValue)
    if (success) {
      url.searchParams.set("status", "success")
    }

    window.location.replace(url)
  }
}
